import { render } from "./ClubsList.vue?vue&type=template&id=1f18f922&scoped=true"
import script from "./ClubsList.vue?vue&type=script&lang=js"
export * from "./ClubsList.vue?vue&type=script&lang=js"

import "./ClubsList.vue?vue&type=style&index=0&id=1f18f922&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f18f922"]])

export default __exports__